import { Link } from "react-router-dom";
import { ShieldCheck, Phone, Mail, AlertTriangle } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2c3e50] text-white" data-testid="footer">
      {/* Disclaimer Banner */}
      <div className="bg-[#f39c12] text-[#2c3e50] py-4 px-4">
        <div className="max-w-6xl mx-auto flex items-start gap-3">
          <AlertTriangle className="w-6 h-6 flex-shrink-0 mt-1" />
          <p className="text-base font-medium">
            <strong>Important Notice:</strong> Protect Elders from Fraud (PEFF) is a private initiative and is NOT an official government website or affiliated with the Indian Police. We do not guarantee money recovery. We assist in organizing data and tracking status.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & About */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <ShieldCheck className="w-10 h-10 text-[#e74c3c]" />
              <div>
                <span className="text-2xl font-bold font-['Manrope']">PEFF</span>
                <p className="text-sm text-slate-300">Protect Elders from Fraud</p>
              </div>
            </div>
            <p className="text-slate-300 text-base leading-relaxed mb-4">
              A safe space for Indian senior citizens to report financial scams, track investigations, and find support. We are committed to helping elders recover their dignity and funds.
            </p>
            <div className="flex items-center gap-2 text-[#e74c3c]">
              <Phone className="w-5 h-5" />
              <span className="font-bold">National Cyber Crime Helpline: 1930</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 font-['Manrope']">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/report" className="text-slate-300 hover:text-white text-base transition-colors" data-testid="footer-report-link">
                  Report a Scam
                </Link>
              </li>
              <li>
                <Link to="/track" className="text-slate-300 hover:text-white text-base transition-colors" data-testid="footer-track-link">
                  Track Your Case
                </Link>
              </li>
              <li>
                <Link to="/knowledge" className="text-slate-300 hover:text-white text-base transition-colors" data-testid="footer-knowledge-link">
                  Help Guide
                </Link>
              </li>
              <li>
                <Link to="/volunteer" className="text-slate-300 hover:text-white text-base transition-colors" data-testid="footer-volunteer-link">
                  Volunteer Signup
                </Link>
              </li>
              <li>
                <Link to="/donate" className="text-slate-300 hover:text-white text-base transition-colors" data-testid="footer-donate-link">
                  Donate Now
                </Link>
              </li>
              <li>
                <a 
                  href="https://cybercrime.gov.in" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-300 hover:text-white text-base transition-colors"
                  data-testid="footer-cybercrime-link"
                >
                  Official Cyber Crime Portal
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-bold mb-4 font-['Manrope']">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-slate-300 hover:text-white text-base transition-colors" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-300 hover:text-white text-base transition-colors" data-testid="footer-terms-link">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-slate-300 hover:text-white text-base transition-colors" data-testid="footer-disclaimer-link">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-600 mt-8 pt-8 text-center">
          <p className="text-slate-400 text-base">
            © {currentYear} Protect Elders from Fraud (PEFF). All rights reserved.
          </p>
          <p className="text-slate-500 text-sm mt-2">
            This is a private initiative. For official complaints, please visit{" "}
            <a 
              href="https://cybercrime.gov.in" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#e74c3c] hover:underline"
            >
              cybercrime.gov.in
            </a>
          </p>
          
          {/* Elderra.io Branding */}
          <div className="mt-6 pt-6 border-t border-slate-600">
            <p className="text-slate-400 text-sm mb-3">An initiative by</p>
            <a 
              href="https://elderra.io" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 hover:opacity-80 transition-opacity"
              data-testid="elderra-link"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_protect-elders/artifacts/uffkr959_ELDERRA%20LOGO%20%2810%29.png" 
                alt="Elderra.io - Bridging Tech for Seniors" 
                className="h-10 w-auto"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
